/** @format */

import ImageGrid from "@Web/Blocks/ImageGrid";

const Gallery = (props) => {
  return <ImageGrid {...props} number={1} />;
};

export default Gallery;
